import React, { useState } from "react";
import { Row, Col, Card, Table, Tabs, Empty } from "antd";
import "../css/strategy.css";

const GOLD = "#d09d4c";
const GRAY = "#808080";
const WHITE = "#ffffff";

const TradesSection = ({ data }) => {
  const [tab, setTab] = useState("all");

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      width: 125,
    },
    {
      title: "Instrument",
      dataIndex: "instrument",
      key: "instrument",
      width: 130,
    },
    {
      title: "Entry",
      dataIndex: "entry",
      key: "entry",
      width: 100,
      render: (value) =>
        typeof value === "number" ? value.toLocaleString("en-IN") : value,
    },
    {
      title: "P&L",
      dataIndex: "pnl",
      key: "pnl",
      width: 130,
      render: (value) => (
        <span
          className={`trade-pnl ${
            value > 0 ? "trade-profit" : value < 0 ? "trade-loss" : ""
          }`}
        >
          {value < 0 ? "-₹" : "₹"}
          {Math.abs(value).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </span>
      ),
    },
  ];

  const trades =
    tab === "wins"
      ? data?.win_loss?.wins || []
      : tab === "loss"
      ? data?.win_loss?.losses || []
      : data?.win_loss?.all || [];

  const tableData = trades.map((trade, index) => ({
    key: trade.id || trade._id || index,
    date: trade.opening_date
      ? new Date(trade.opening_date).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
      : "-",
    instrument: trade.symbol || "-",
    entry: trade.opening_price ?? "-",
    pnl: Number(trade.profit) || 0,
    rr: trade.rr || "-",
  }));

  return (
    <Row gutter={[16, 16]} className="trades-section-glass">
      {/* LEFT: TRADES TABLE */}
      <Col xs={24} lg={14}>
        <Card
          title="Trades"
          className="trades-glass-card"
          bordered={false}
        >
          <Tabs
            className="trades-glass-tabs"
            activeKey={tab}
            onChange={setTab}
            items={[
              { key: "all", label: "All Trades" },
              { key: "wins", label: "Wins" },
              { key: "loss", label: "Losses" },
            ]}
          />

          <Table
            className="trades-glass-table"
            columns={columns}
            dataSource={tableData}
            pagination={false}
            size="small"
            scroll={{ x: 485 }}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="No trades available"
                />
              ),
            }}
          />
        </Card>
      </Col>

      {/* RIGHT: RECENT TRADES */}
      <Col xs={24} lg={10}>
        <Card
          title="Recent Trades"
          className="trades-glass-card recent-trades-card"
          bordered={false}
        >
          {tableData.length === 0 ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No recent trades"
            />
          ) : (
            tableData.slice(0, 5).map((item) => (
              <div className="recent-trade-item" key={item.key}>
                <div className="recent-trade-info">
                  <div className="recent-trade-symbol">
                    {item.instrument}
                  </div>

                  <div className="recent-trade-date">{item.date}</div>
                </div>

                <div className="recent-trade-numbers">
                  <div className="recent-trade-entry">
                    Entry: {item.entry}
                  </div>

                  <div
                    className={`trade-pnl ${
                      item.pnl > 0
                        ? "trade-profit"
                        : item.pnl < 0
                        ? "trade-loss"
                        : ""
                    }`}
                  >
                    {item.pnl < 0 ? "-₹" : "₹"}
                    {Math.abs(item.pnl).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </div>
                </div>
              </div>
            ))
          )}
        </Card>
      </Col>
    </Row>
  );
};

export default TradesSection;